export default {
  TEXT_INDENT_TRIGGER_ID: 'indent',
  TEXT_OUTDENT_TRIGGER_ID: 'outdent',
};
